<template>
  <v-container fluid>
    <div class="d-flex justify-space-between align-center py-2">
      <span class="font-weight-medium py-2 flex-shrink-0">
        จัดการข้อมูลการลา
      </span>
      <v-spacer></v-spacer>
      <v-btn
        :disabled="uiCtrl && !uiCtrl.isEnable('btn:::leave:file:import')"
        depressed
        class="mr-3"
        @click="handleLeaveFileImport"
        >Import</v-btn
      >
      <v-btn
        :disabled="uiCtrl && !uiCtrl.isEnable('btn:::leave:file:export')"
        depressed
        color="primary"
        @click="handleLeaveFileExport"
        >Export</v-btn
      >
    </div>
    <v-card outlined>
      <v-row align="center" class="ma-0">
        <v-col md="3" lg="3" xl="2">
          <v-text-field
            v-model="search"
            prepend-inner-icon="mdi-magnify"
            clearable
            dense
            outlined
            hide-details
            placeholder="เลขที่ใบลา, รหัส - ชื่อพนักงาน"
            @input="handleSearch"
          ></v-text-field>
        </v-col>
        <!-- <v-col md="3" lg="3" xl="2">
          <v-autocomplete
            v-model="filterIsApproved"
            :items="[
              { id: 1, title_th: 'อนุมัติ', value: 'true' },
              { id: 2, title_th: 'ไม่อนุมัติ', value: 'false' },
              { id: 3, title_th: 'ยังไม่จัดการ', value: 'null' }
            ]"
            item-text="title_th"
            item-value="value"
            label="สถานะการลา"
            prepend-inner-icon="mdi-filter-variant"
            clearable
            dense
            outlined
            hide-details
            @change="handleFilterIsApproved"
          ></v-autocomplete>
        </v-col> -->
        <v-col md="3" lg="3" xl="2">
          <v-autocomplete
            v-model="filterLeaveType"
            :items="leaveTypes"
            item-text="title_th"
            item-value="leave_type_uuid"
            label="ประเภทการลา"
            prepend-inner-icon="mdi-filter-variant"
            clearable
            dense
            outlined
            hide-details
            @change="handleFilterLeaveType"
          ></v-autocomplete>
        </v-col>
        <v-col md="3" lg="3" xl="2">
          <v-autocomplete
            v-model="filterIsProcessed"
            :items="[
              { id: 1, title_th: 'จัดการสำเร็จ', value: 'true' },
              { id: 2, title_th: 'จัดการไม่สำเร็จ', value: 'false' },
              { id: 3, title_th: 'ยังไม่จัดการ', value: 'null' },
            ]"
            item-text="title_th"
            item-value="value"
            label="สถานะจัดการข้อมูล"
            prepend-inner-icon="mdi-filter-variant"
            clearable
            dense
            outlined
            hide-details
            @change="handleFilterIsProcessed"
          ></v-autocomplete>
        </v-col>
      </v-row>
    </v-card>
    <v-data-table
      :sort-by="sortBy"
      :sort-desc="sortDesc"
      :loading="loading"
      loading-text="Loading... Please wait"
      :headers="headers"
      :items="leaveRecords"
      :options.sync="options"
      :server-items-length="totalLeaveRecords"
      :items-per-page="10"
      class="elevation-1 mt-3"
      :footer-props="{
        itemsPerPageOptions: [10, 25, 50, 100],
        itemsPerPageText: 'Rows per page:',
      }"
    >
      <template v-slot:item.is_approved="{ item }">
        <v-chip v-if="item.is_approved === null" small dark color="warning">
          <span style="font-weight: 600"> ยังไม่จัดการ </span>
        </v-chip>
        <v-chip v-if="item.is_approved === true" small dark color="success">
          <span style="font-weight: 600"> อนุมัติ </span>
        </v-chip>
        <v-chip v-if="item.is_approved === false" small dark color="error">
          <span style="font-weight: 600"> ไม่อนุมัติ </span>
        </v-chip>
      </template>
      <template v-slot:item.is_processed_success="{ item }">
        <v-btn
          @click="handleOnClickProcessed(item)"
          depressed
          rounded
          small
          :color="
            item.is_processed_success === null
              ? 'warning'
              : item.is_processed_success === true
              ? 'success'
              : 'error'
          "
        >
          <span
            v-if="item.is_processed_success === null"
            style="font-weight: 600"
          >
            ยังไม่จัดการ
          </span>
          <span
            v-if="item.is_processed_success === true"
            style="font-weight: 600"
          >
            จัดการสำเร็จ
          </span>
          <span
            v-if="item.is_processed_success === false"
            style="font-weight: 600"
          >
            จัดการไม่สำเร็จ
          </span>
        </v-btn>
      </template>
      <template v-slot:item.employee="{ item }">
        <div>
          {{ item.employee.firstname_th }} {{ item.employee.lastname_th }}
        </div>
      </template>
      <template v-slot:item.approver_employee="{ item }">
        <div>
          {{ item.approver_employee.firstname_th }}
          {{ item.approver_employee.lastname_th }}
        </div>
      </template>
      <template v-slot:item.datetime="{ item }">
        <div>
          {{ item.start_date | formatDate }} {{ item.start_time }} -
          <span v-if="item.end_date === null">{{
            item.start_date | formatDate
          }}</span>
          <span v-else>{{ item.end_date | formatDate }}</span>
          {{ item.end_time }}
        </div>
      </template>
      <template v-slot:item.time_sum="{ item }">
        <div>
          {{ item.day }} วัน / {{ item.hour }} ชม. / {{ item.minute }} นาที
        </div>
      </template>
    </v-data-table>
    <v-dialog v-model="dialogProgress" persistent width="320">
      <div class="pa-4 white">
        <v-progress-linear :value="progressValue" height="25">
          <strong>{{ Math.ceil(progressValue) }}%</strong>
        </v-progress-linear>
      </div>
    </v-dialog>
    <v-dialog v-model="dialogLeaveInfo" max-width="360">
      <v-card>
        <v-card-title class="text-h5"> ข้อมูลการลา </v-card-title>
        <v-card-text
          v-if="leaveInfo.employee"
          style="font-size: 16px; font-weight: 600"
        >
          {{ leaveInfo.employee.firstname_th }}
          {{ leaveInfo.employee.lastname_th }}
        </v-card-text>
        <v-card-text v-if="leaveInfo.this_leave" class="pb-2">
          <div style="font-weight: 600">
            <span v-if="leaveInfo.this_leave.title_th"
              >{{ leaveInfo.this_leave.title_th }} :
            </span>
            <span v-if="leaveInfo.this_leave.day > 0"
              >{{ leaveInfo.this_leave.day }} วัน
            </span>
            <span v-if="leaveInfo.this_leave.hour > 0">
              / {{ leaveInfo.this_leave.hour }} ชั่วโมง
            </span>
            <span v-if="leaveInfo.this_leave.minute > 0">
              / {{ leaveInfo.this_leave.minute }} นาที</span
            >
            <span
              v-if="
                !leaveInfo.this_leave.day &&
                !leaveInfo.this_leave.hour &&
                !leaveInfo.this_leave.minute
              "
              >-</span
            >
          </div>
        </v-card-text>
        <v-card-text v-if="leaveInfo.quota_leave" class="pb-2">
          <div style="font-weight: 600">
            <span v-if="leaveInfo.quota_leave.title_th"
              >{{ leaveInfo.quota_leave.title_th }} :
            </span>
            <span v-if="leaveInfo.quota_leave.day > 0"
              >{{ leaveInfo.quota_leave.day }} วัน
            </span>
            <span v-if="leaveInfo.quota_leave.hour > 0">
              / {{ leaveInfo.quota_leave.hour }} ชั่วโมง
            </span>
            <span v-if="leaveInfo.quota_leave.minute > 0">
              / {{ leaveInfo.quota_leave.minute }} นาที</span
            >
            <span
              v-if="
                !leaveInfo.quota_leave.day &&
                !leaveInfo.quota_leave.hour &&
                !leaveInfo.quota_leave.minute
              "
              >-</span
            >
          </div>
        </v-card-text>
        <v-card-text v-if="leaveInfo.used_leave">
          <div style="font-weight: 600">
            <span v-if="leaveInfo.used_leave.title_th"
              >{{ leaveInfo.used_leave.title_th }} :
            </span>
            <span v-if="leaveInfo.used_leave.day > 0"
              >{{ leaveInfo.used_leave.day }} วัน
            </span>
            <span v-if="leaveInfo.used_leave.hour > 0">
              / {{ leaveInfo.used_leave.hour }} ชั่วโมง
            </span>
            <span v-if="leaveInfo.used_leave.minute > 0">
              / {{ leaveInfo.used_leave.minute }} นาที</span
            >
            <span
              v-if="
                !leaveInfo.used_leave.day &&
                !leaveInfo.used_leave.hour &&
                !leaveInfo.used_leave.minute
              "
              >-</span
            >
          </div>
        </v-card-text>
        <v-card-text
          v-if="
            leaveInfo.this_leave ||
            leaveInfo.quota_leave ||
            leaveInfo.used_leave
          "
        >
          <div style="font-weight: 600">
            Note :
            {{ leaveInfo.processed_note ? leaveInfo.processed_note : '-' }}
          </div>
        </v-card-text>
        <v-card-text
          v-if="
            !leaveInfo.this_leave &&
            !leaveInfo.quota_leave &&
            !leaveInfo.used_leave
          "
        >
          <div style="font-weight: 600">- ไม่พบข้อมูลการลา</div>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="dialogLeaveInfo = false">
            ปิด
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <UploadDialog
      :uploadDialog="uploadDialog"
      uploadDialogTitle="นำเข้าข้อมูลการลา"
      :downloadExampleFileImportDataUrl="exampleFileImportDataUrl"
      downloadExampleFileImportDataName="leave_file_import_example.txt"
      :fileInputAccept="'.txt'"
      @selectedFile="selectedFile"
      @handleCancelUploadDialog="handleCancelUploadDialog"
      @uploadFile="uploadFile"
    />
    <UploadDialogMessage
      :uploadDialogMessage="uploadDialogMessage"
      uploadDialogMessageTitle="นำเข้าข้อมูลการลาไม่สำเร็จ"
      :downloadFileImportDataUrl="fileImportDataUrl"
      :downloadFileImportDataName="fileImportDataName"
      @onClose="uploadDialogMessage = false"
    />
  </v-container>
</template>

<script>
import _ from 'lodash'
import moment from 'moment'
import { mapActions } from 'vuex'

import UploadDialog from '@/components/UploadDialog.vue'
import UploadDialogMessage from '@/components/UploadDialogMessage.vue'

export default {
  components: {
    UploadDialog,
    UploadDialogMessage,
  },
  data() {
    return {
      dialogLeaveInfo: false,
      leaveInfo: {},
      exampleFileImportDataUrl: '',
      currentFile: null,
      uploadDialog: false,
      uploadDialogMessage: false,
      fileImportDataUrl: '',
      fileImportDataName: '',
      loading: false,
      sortBy: ['leave_record_number'],
      sortDesc: [false],
      search: '',
      options: {},
      headers: [
        {
          text: 'เลขที่ใบลา',
          align: 'start',
          value: 'leave_record_number',
          width: 160,
          class: 'text-no-wrap',
        },
        // {
        //   text: 'สถานะการลา',
        //   value: 'is_approved',
        //   sortable: false,
        //   class: 'text-no-wrap'
        // },
        { text: 'พนักงาน', value: 'employee', class: 'text-no-wrap' },
        {
          text: 'ประเภทการลา',
          value: 'leave_type.title_th',
          sortable: false,
          class: 'text-no-wrap',
        },
        {
          text: 'วันที่ - เวลา',
          value: 'datetime',
          sortable: false,
          class: 'text-no-wrap',
        },
        {
          text: 'เวลารวม',
          value: 'time_sum',
          sortable: false,
          class: 'text-no-wrap',
        },
        {
          text: 'ผู้อนุมัติการลา',
          value: 'approver_employee',
          class: 'text-no-wrap',
        },
        {
          text: 'สถานะจัดการข้อมูล',
          value: 'is_processed_success',
          sortable: false,
          class: 'text-no-wrap',
        },
      ],
      filterLeaveType: null,
      // filterIsApproved: null,
      filterIsProcessed: null,
      dialogProgress: false,
      progressValue: 0,
      interval: null,
      timeout: null,
    }
  },
  watch: {
    options: {
      handler() {
        this.getLeaveRecords()
      },
      deep: true,
    },
  },
  filters: {
    formatDate: function (value) {
      return moment.utc(value).format('DD/MM/YYYY')
    },
  },
  computed: {
    uiCtrl() {
      return this.$store.state.uiCtrl
    },
    leaveRecords() {
      return this.$store.state.leaveFile.leaveRecords
    },
    totalLeaveRecords() {
      return this.$store.state.leaveFile.totalLeaveRecords
    },
    leaveTypes() {
      return this.$store.state.leaveType.leaveTypes
    },
  },
  async created() {
    this.$store.commit('SET_BREADCRUMBS', [
      { text: 'หน้าหลัก', disabled: false, to: '/' },
      {
        text: 'จัดการข้อมูลการลา',
        disabled: true,
      },
    ])

    try {
      const { company_uuid } = this.$store.state.authentication.company

      this.$store.state.loading = true

      const [_, url] = await Promise.all([
        this.fetchLeaveTypes({
          company_uuid,
          params: {
            dpc: 'leave-file-to-list-leave-type',
            field: 'leave_type_uuid,title_th',
          },
        }),
        this.leaveFileImportExample({
          company_uuid,
        }),
      ])

      this.exampleFileImportDataUrl = url
    } catch (error) {
      const snackbar = {
        show: true,
        color: 'error',
        timeout: -1,
        message: error?.response?.data?.message || 'Something went wrong!',
      }
      this.$store.commit('SET_SNACKBAR', snackbar)
    } finally {
      this.$store.state.loading = false
    }
  },
  methods: {
    ...mapActions({
      fetchLeaveRecords: 'leaveFile/fetchLeaveRecords',
      fetchLeaveTypes: 'leaveType/fetchLeaveTypes',
      leaveFileImport: 'leaveFile/leaveFileImport',
      leaveFileExport: 'leaveFile/leaveFileExport',
      generateFileProgress: 'download/generateFileProgress',
      leaveFileImportExample: 'leaveFile/leaveFileImportExample',
      leaveFileImport: 'leaveFile/leaveFileImport',
    }),
    handleOnClickProcessed(item) {
      this.dialogLeaveInfo = true

      this.leaveInfo = {
        employee: {
          ...item.employee,
        },
        this_leave: item.this_leave
          ? {
              ...item.this_leave,
            }
          : undefined,
        quota_leave: item.quota_leave
          ? {
              ...item.quota_leave,
            }
          : undefined,
        used_leave: item.used_leave
          ? {
              ...item.used_leave,
            }
          : undefined,
        processed_note: item.processed_note ? item.processed_note : undefined,
      }
    },
    uploadFile(refs) {
      if (this.currentFile) {
        let formData = new FormData()
        formData.append('file', this.currentFile)

        const { company_uuid } = this.$store.state.authentication.company

        const payload = {
          company_uuid,
          formData,
        }

        this.$store.state.loading = true

        this.leaveFileImport(payload)
          .then((data) => {
            this.$store.state.loading = false
            this.uploadDialog = false
            refs.clearableCallback()

            this.progressValue = 0
            this.dialogProgress = true
            this.uploadProgress(data.job_process_uuid, data.ping_after_ms)
          })
          .catch((error) => {
            this.$store.state.loading = false
            this.uploadDialog = false

            const snackbar = {
              show: true,
              color: 'error',
              timeout: -1,
              message:
                error?.response?.data?.message || 'Something went wrong!',
            }
            this.$store.commit('SET_SNACKBAR', snackbar)
          })
      } else {
        const snackbar = {
          show: true,
          color: 'warning',
          timeout: 4000,
          message: 'ไม่ได้เลือกไฟล์ใด',
        }

        this.$store.commit('SET_SNACKBAR', snackbar)
      }
    },
    uploadProgress(job_process_uuid, ping_after_ms) {
      this.interval = setInterval(() => {
        this.generateFileProgress(job_process_uuid)
          .then((res) => {
            if (res.is_success) {
              this.progressValue = 100
              this.timeout = setTimeout(() => {
                this.dialogProgress = false
              }, 200)

              clearInterval(this.interval)

              if (res.resource_json?.total_fail > 0) {
                const fileUrl = res.resource_uri
                const fileName = fileUrl.split('/').pop()
                this.fileImportDataUrl = fileUrl
                this.fileImportDataName = fileName
                this.timeout = setTimeout(() => {
                  this.uploadDialogMessage = true
                }, 300)
              } else {
                this.getLeaveRecords()

                this.timeout = setTimeout(() => {
                  const snackbar = {
                    show: true,
                    color: 'success',
                    timeout: 3000,
                    message: 'นำเข้าข้อมูลสำเร็จ',
                  }

                  this.$store.commit('SET_SNACKBAR', snackbar)
                }, 300)
              }
            } else {
              this.progressValue = (100 / res.total) * res.progress
            }
          })
          .catch((error) => {
            clearInterval(this.interval)
            this.dialogProgress = false

            const snackbar = {
              show: true,
              color: 'error',
              timeout: -1,
              message:
                error?.response?.data?.message || 'Something went wrong!',
            }
            this.$store.commit('SET_SNACKBAR', snackbar)

            clearInterval(this.interval)
          })
      }, ping_after_ms)
    },
    handleSearch() {
      this.loading = true
      this.getLeaveRecordsBySearch()
    },
    handleFilterLeaveType() {
      this.options.page = 1
      this.getLeaveRecords()
    },
    // handleFilterIsApproved() {
    //   this.options.page = 1
    //   this.getLeaveRecords()
    // },
    handleFilterIsProcessed() {
      this.options.page = 1
      this.getLeaveRecords()
    },
    getLeaveRecordsBySearch: _.debounce(function () {
      this.options.page = 1
      this.getLeaveRecords()
    }, 1000),
    getLeaveRecords() {
      this.loading = true

      const { sortBy, sortDesc, page, itemsPerPage } = this.options

      let sort = ''
      const sortByKey = sortBy[0] || ''

      if (sortByKey === 'leave_record_number') sort = 'leave_record_number'
      if (sortByKey === 'employee') sort = 'firstname_th'
      if (sortByKey === 'approver_employee') sort = 'approver_firstname_th'

      if (sortDesc.length > 0) {
        if (sortDesc[0]) {
          sort += `,desc`
        } else {
          sort += `,asc`
        }
      }

      const { company_uuid } = this.$store.state.authentication.company

      const payload = {
        company_uuid,
        params: {
          search: this.search || undefined,
          leave_type_uuid: this.filterLeaveType || undefined,
          // is_approved: this.filterIsApproved || undefined,
          is_processed_success: this.filterIsProcessed || undefined,
          sort,
          limit: `${itemsPerPage},${(page - 1) * itemsPerPage}`,
        },
      }

      this.fetchLeaveRecords(payload)
        .then(() => {
          this.loading = false
        })
        .catch((error) => {
          this.loading = false

          const snackbar = {
            show: true,
            color: 'error',
            timeout: -1,
            message: error?.response?.data?.message || 'Something went wrong!',
          }
          this.$store.commit('SET_SNACKBAR', snackbar)
        })
    },
    selectedFile(file) {
      this.currentFile = file
    },
    handleCancelUploadDialog(refs) {
      this.uploadDialog = false
      this.currentFile = null
      refs.clearableCallback()
    },
    handleLeaveFileImport() {
      this.uploadDialog = true
    },
    handleLeaveFileExport() {
      const { sortBy, sortDesc, page, itemsPerPage } = this.options

      let order_by = ''
      const sortByKey = sortBy[0] || ''

      if (sortByKey === 'leave_record_number') order_by = 'leave_record_number'
      if (sortByKey === 'employee') order_by = 'firstname_th'
      if (sortByKey === 'approver_employee') order_by = 'approver_firstname_th'

      if (sortDesc.length > 0) {
        if (sortDesc[0]) {
          order_by += `,desc`
        } else {
          order_by += `,asc`
        }
      }

      const { company_uuid } = this.$store.state.authentication.company

      const payload = {
        company_uuid,
      }

      this.leaveFileExport(payload)
        .then((res) => {
          this.progressValue = 0
          this.dialogProgress = true

          this.downloadProgress(res.job_process_uuid, res.ping_after_ms)
        })
        .catch((error) => {
          this.dialogProgress = false

          const snackbar = {
            show: true,
            color: 'error',
            timeout: -1,
            message: error?.response?.data?.message || 'Something went wrong!',
          }
          this.$store.commit('SET_SNACKBAR', snackbar)
        })
    },
    downloadProgress(job_process_uuid, ping_after_ms) {
      this.interval = setInterval(() => {
        this.generateFileProgress(job_process_uuid)
          .then((res) => {
            if (res.is_success) {
              this.progressValue = 100
              this.timeout = setTimeout(() => {
                this.dialogProgress = false
              }, 200)

              const fileUrl = res.resource_uri
              const fileName = fileUrl.split('/').pop()

              const a = document.createElement('a')
              a.setAttribute('hidden', '')
              a.setAttribute('href', fileUrl)
              a.setAttribute('target', '_blank')
              a.setAttribute('download', fileName)
              document.body.appendChild(a)
              a.click()
              document.body.removeChild(a)

              clearInterval(this.interval)
            } else {
              this.progressValue = (100 / res.total) * res.progress
            }
          })
          .catch((error) => {
            this.dialogProgress = false

            const snackbar = {
              show: true,
              color: 'error',
              timeout: -1,
              message:
                error?.response?.data?.message || 'Something went wrong!',
            }
            this.$store.commit('SET_SNACKBAR', snackbar)

            clearInterval(this.interval)
          })
      }, ping_after_ms)
    },
  },
  beforeDestroy() {
    clearTimeout(this.timeout)
  },
}
</script>
